import * as React from 'react';

export type HighlighterEmphasize = 'text' | 'background';

export interface HighlighterProps {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** match to highlight */
  match?: string;
  children?: React.ReactNode;
  /** style of highlight */
  emphasize?: HighlighterEmphasize;
}

export interface HighlightedItemProps {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** match to highlight */
  match?: string;
  children?: React.ReactNode;
  /** style of highlight */
  emphasize?: HighlighterEmphasize;
  /** whether the match should be case sensitive */
  caseSensitive?: boolean;
}
